import { Flex, Text } from '@bitrise/bitkit';
import { BuildMetricsTimeSeries } from '@trace/types';
import React, { FunctionComponent } from 'react';
import { DurationUnit } from 'luxon';
import { metrics } from './BuildTimesByStatus';
import { BUILD_METRIC_COLORS, BUILD_METRIC_NAMES } from '../mappings';
import getFormattedValue from '../../../utils/metric/getFormattedValue';
import getTimeRangeString from '../getTimeRangeString';

type Props = {
  dataOverTime: BuildMetricsTimeSeries;
  step: DurationUnit;
  stepSize: number;
  timestamp: number;
  x: number;
};

const BuildTimesByStatusTooltipContent: FunctionComponent<Props> = ({
  dataOverTime,
  step,
  stepSize,
  timestamp,
  x,
}) => {
  return (
    <Flex>
      <Text config="9" align="middle" margin="x2">
        {getTimeRangeString(timestamp, step, stepSize)}
      </Text>

      {metrics.map((metric, index) => (
        <Flex direction="horizontal" gap="x4" key={metric}>
          <Flex
            backgroundColor={BUILD_METRIC_COLORS[metric]}
            key={metric}
            style={{
              borderTopLeftRadius: index === 0 ? '4px' : undefined,
              borderTopRightRadius: index === 0 ? '4px' : undefined,
            }}
            width="8px"
          />

          <Flex grow>
            <Text config="8" weight="bold">
              {BUILD_METRIC_NAMES[metric]}
            </Text>
          </Flex>

          <Flex>
            <Text align="end" config="8">
              {getFormattedValue('seconds', dataOverTime[metric][x])}
            </Text>
          </Flex>
        </Flex>
      ))}
    </Flex>
  );
};

export default BuildTimesByStatusTooltipContent;
